module.exports = __webpack_public_path__ + "img/banner_about_2.cd26c533.png";